import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import About from "./pages/about";
import Login from "./pages/Login";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import ForgotPin from "./components/ForgotPin";
import SignUpForm from "./components/SignUpForm";
import KnowledgeCenter from "./components/KnowledgeCenter";
import EpcJourney from "./components/EPC/EpcJourney";
import ForgotPassword from "./components/EPC/ForgotPassword/ForgotPassword";
import EpcDashboard from "./components/EPC/EpcJourney/EpcDashboard";
import ResetPassword from "./components/EPC/ResetPassword/ResetPassword";
import EpcLogin from "./components/EPC/EpcLogin";
import CohostForm from "./components/EPC/CohostForm";
import EntityLogin from "./pages/EntityInformation";
import EntityInfo from "./components/EntityInformationStation/EntityInfo";
import { IsoftForm } from "./components/IsoftForm";
import { Document } from "./pages/Document";
import GemDashboard from "./components/EPC/GemJourney/EpcDashboard";
import { RootState, useAppDispatch, useAppSelector } from "./store/store";
import { Redirect } from "./components/IsoftForm/redirect";
import Test from "./InceptionProject/Test";
import LoginProforma from "./pages/LoginProforma";
import ProformaFormV1 from "./components/Proforma/ProformaFormV1";
import ProformaFormV2 from "./components/Proforma/ProformaFormV2";
import PurlDashboard from "./components/PurlDashboard";
import { setUserFolderId } from "./store/reducers/usersReducer";
import { setStage } from "./store/reducers/stageReducer";
import { toggleSubmission } from "./store/reducers/tileReducer";
import InactivityTimer from "./helpers/InactivityTimer";
import { config } from "./configs/index";
import PurlAuthHandler from "./helpers/PurlAuthHandler";
import {
  useGetPurlDocumentStatusQuery,
  useGetStagesQuery,
  useLazyGetStagesQuery,
  useLazyGetUserFlowQuery,
} from "./services/api";
import { setUserFlow } from "./store/reducers/userFlowReducer";
import LegacyIdRedirect from "./helpers/LegacyIdRedirect";
import ReloadUserFlowHandler from "./helpers/ReloadUserFlowHandler";
import { setUserLogin } from "./store/reducers/loginReducer";
import AuthCallback from "./pages/AuthCallback";
import { useAuth0 } from "@auth0/auth0-react";
import LoginChoice from "./pages/LoginChoice";
import SetPassword from "./components/MasterUser/SetPassword/SetPassword";
import MasterUserRoute from "./helpers/MasterUserRoute";
import Users from "./pages/Users";
import ImpersonationBanner from "./components/MasterUser/ImpersonationBanner/ImpersonationBanner";
import Onboarding from "./pages/Onboarding";
import StrategyVideo from "./components/OnboardingComponents/StrategyVideo";
import ScheduleCall from "./components/OnboardingComponents/ScheduleCall";
import NotFound from "./pages/NotFound";

interface URL {
  url: string;
}

const RedirectComponent = ({ url }: URL) => {
  const navigate = useNavigate();
  useEffect(() => {
    window.open(url, "_blank", "noopener,noreferrer");
    navigate("/");
  }, [url, navigate]);

  return <div>Redirecting...</div>;
};

function App() {
  const epcUser = useSelector((state: RootState) => state.epcUser.email);
  const purlUser = useSelector((state: RootState) => state.login._id);
  const proformaUser = useSelector(
    (state: RootState) => state.proformaUser.name
  );
  const isNewVersion = useSelector(
    (state: RootState) => state.proformaUser.isNewVersion
  );
  const [getStages, { data, error, isLoading }] = useLazyGetStagesQuery();
  const isPurLogin = localStorage.getItem("token");
  const dispatch = useAppDispatch();
  const [customizations, setCustomizations] = useState({
    fontSize: "16px",
    fontFamily: "Arial, sans-serif",
    fontWeight: "normal",
    backgroundColor: "white",
    textColor: "black",
  });

  const userData = localStorage.getItem("user");
  const parsedUserData = userData ? JSON.parse(userData) : {};
  const [triggerUserFlow, { data: userFlowData }] = useLazyGetUserFlowQuery();
  const user = useSelector((state: RootState) => state.login);

  const zohoCustomerId = user.zohoCustomerId;
  const { data: purlStatusData } = useGetPurlDocumentStatusQuery(
    { id: zohoCustomerId },
    { skip: !zohoCustomerId }
  );

  const purlDocuments = purlStatusData?.data?.result?.purlDocuments;

  useEffect(() => {
    if (typeof purlDocuments === "boolean") {
      dispatch(
        setUserLogin({
          ...user,
          purlDocuments,
        })
      );
    }
  }, [purlDocuments, dispatch]);

  useEffect(() => {
    const fetchCustomizations = async () => {
      try {
        console.log("Welcome to Inception.");
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${config.REACT_APP_BASE_URL}/api/admin/customization`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setCustomizations(data.data);
        applyCustomizations(data.data);
      } catch (error) {
        console.error("Error fetching customizations:", error);
      }
    };
    fetchCustomizations();
  }, []);

  const applyCustomizations = (data: any) => {
    document.documentElement.style.setProperty("--font-size", data.fontSize);
    document.documentElement.style.setProperty(
      "--font-family",
      data.fontFamily
    );
    document.documentElement.style.setProperty(
      "--font-weight",
      data.fontWeight
    );
    document.documentElement.style.setProperty(
      "--background-color",
      data.backgroundColor
    );
    document.documentElement.style.setProperty("--text-color", data.textColor);
  };

  const getStagesData = async () => {
    const response = await getStages();
    const data = response?.data?.data ?? {};
    dispatch(setStage(data));
  };

  useEffect(() => {
    console.log("Inception_Financial");
    //TODO - fix this
    const folderId = localStorage.getItem("folderId");
    folderId && dispatch(setUserFolderId(folderId));

    // const newStateData = localStorage.getItem("newStateData");
    const token = localStorage.getItem("token");
    // newStateData && dispatch(setStage(JSON.parse(newStateData)));
    // token && getStagesData();

    const tile2 = localStorage.getItem("tile2");
    tile2 && dispatch(toggleSubmission({ component: "tile2" }));

    const tile5 = localStorage.getItem("tile5");
    tile5 && dispatch(toggleSubmission({ component: "tile5" }));
  }, []);

  console.log("Welcome to INCEPTION");

  return (
    <BrowserRouter>
      <InactivityTimer />
      <Routes>
        <Route
          path="/proforma"
          element={
            proformaUser ? (
              isNewVersion ? (
                <ProformaFormV2 />
              ) : (
                <ProformaFormV1 />
              )
            ) : (
              <LoginProforma />
            )
          }
        />
        <Route element={<PurlAuthHandler isProtected={false} />}>
          {/* old auth */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginChoice />} />
          <Route path="/callback" element={<AuthCallback />} />
          {/* <Route path="/forgot-pin" element={<ForgotPin />} />
          <Route path="/forgot-pin/:uniqueid" element={<ForgotPin />} /> */}
        </Route>
        <Route path="/strategy-video" element={<StrategyVideo />} />
        <Route path="/schedule-call" element={<ScheduleCall />} />
        <Route element={<PurlAuthHandler isProtected={true} />}>
          <Route path="/onboarding/:id" element={<Onboarding />} />
          <Route
            path="/dashboard/:id"
            element={
              <>
                <ImpersonationBanner />
                <PurlDashboard />
              </>
            }
          />
        </Route>

        {/* Legacy bare "/:uniqueId" route (replaced by "/dashboard/:id"). Redirects
            genuine logged-in users to their dashboard, everyone else to login. */}
        <Route path="/:uniqueId" element={<LegacyIdRedirect />} />

        {/* <Route element={<ReloadUserFlowHandler />}>
          <Route
            path="/:uniqueId"
            element={
              window.location.pathname == "/new-client" ? (
                <Navigate to="/login" replace />
              ) : (
                <>
                  <ImpersonationBanner />
                  <Login />
                </>
              )
            }
          /> 
          <Route path="dashboard" element={<Login />} />
        </Route> */}
        <Route path="/new-client" element={<SignUpForm />} />
        {/* <Route element={<PurlAuthHandler isProtected={true} />}>
          add protected routes here 
        </Route> */}

        <Route path="/knowledge-center" element={<KnowledgeCenter />} />
        {/* <Route path="/entity-login" element={<EntityLogin />} /> */}
        <Route
          path="/entity-formation"
          element={
            // purlUser ? <EntityInfo /> : <Navigate to="/entity-login" replace />
            purlUser ? <EntityInfo /> : <EntityLogin />
          }
        />
        <Route
          path="/ticket"
          element={
            <RedirectComponent url="https://forms.zoho.com/inceptionfinancial956/form/ITRequest" />
          }
        />
        <Route
          path="/auth/master-user/profile-setup/:token"
          element={<SetPassword />}
        />
        <Route element={<MasterUserRoute />}>
          <Route path="/users" element={<Users />} />
        </Route>
        <Route path="/epc" element={<EpcJourney />} />
        <Route path="/epc/forgot-password" element={<ForgotPassword />} />
        <Route path="/epc/reset-password" element={<ResetPassword />} />
        {/* <Route path="/temp-dashboard" element={<PurlDashboard />} /> */}
        <Route
          path="/epc/co-host"
          element={epcUser ? <CohostForm /> : <Navigate to="/epc" replace />}
        />
        <Route
          path="/epc/dashboard"
          element={epcUser ? <EpcDashboard /> : <Navigate to="/epc" replace />}
        />
        <Route
          path="/epc/gem-dashboard"
          element={epcUser ? <GemDashboard /> : <Navigate to="/epc" replace />}
        />
        <Route
          path="/epc/isoftpull/:id"
          // element={
          //   isoftUser || epcUser ? (
          //     <IsoftForm />
          //   ) : (
          //     <Navigate to="/epc" replace />
          //   )
          // }
          element={<IsoftForm />}
        />
        <Route path="/IF_after20" element={<Document />} />
        <Route path="/IF_FMV_Calculation" element={<Document />} />
        <Route path="/IF_Performance_Report" element={<Document />} />
        <Route path="/3468InvestmentCreditTips" element={<Document />} />
        <Route path="/ExampleProductionReport" element={<Document />} />
        <Route path="/QualifyingActivitiesExample" element={<Document />} />

        {/* <Route path="/redirect/isoftpull" element={<Redirect />} /> */}
        {/* <Route path="/redirect-to-isoftpull" element={<Redirect />} /> */}
        {/* <Route path="/test" element={<Test />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
